import * as types from "../constants/ActionTypes";

const tipoIngDesk = (state = null, action) => {
  switch (action.type) {
    case types.CHANGE_TIPOINGDESK:
      return action.tipoIngDesk;
    default:
      return state;
  }
};

export default tipoIngDesk;
